<script>
  // @ts-check
  import EventPreviewList from "$lib/components/EventPreviewList.svelte";
  import { transformListItems } from "$lib/utilities/contentTypes/eventPreviewList";
  import { getContext } from "svelte";

  /** @type { string } */
  let className = "";
  export { className as class };

  /**
   * @type {Date | string}
   * This is largely here for testing as we get a lot of visual and unit test regressions when we rely on the actual date.
   */
  export let todaysDate = new Date().toISOString();

  export let data;

  const epl = getContext("epls")?.[data?.sys?.id] || /** for backward compatibility */ data;
  const itemsData = epl?.fields.listItems || [];
  const themedItems = epl?.fields?.themedItems ?? [];
  const featuredItems = epl?.fields?.featuredItems ?? [];
  const excludedItems = epl?.fields?.excludedItems ?? [];
  const maxItems = epl?.fields?.maxItems;
  const startDate = epl?.fields?.startDate;
  const endDate = epl?.fields?.endDate;
  const showMonth = !!epl?.fields?.showMonth;
  const formFactor = epl?.fields?.formFactor || "Calendar Grid";
  const isToursEPL = epl?.fields?.typeFilter?.every((type) => type === "Tour");

  // optional fields on contentful EPL:
  const title = epl?.fields?.displayTitle;
  const cta = epl?.fields?.link
    ? {
        text:
          epl?.fields?.link?.fields?.text ||
          epl?.fields?.link?.fields?.destination?.fields?.textLinkDisplayText,
        url: epl?.fields?.link?.fields?.destination?.fields.url
      }
    : null; // section wants a "cta", even though it's a link contentType. So I'll call it cta here to prevent changing the contract of section.
  const transformedItems = transformListItems({
    items: itemsData,
    themedItems,
    featuredItems,
    excludedItems,
    showMonth,
    maxItems,
    startDate,
    endDate,
    formFactor,
    todaysDate
  });

  const hasItems = transformedItems.items.length || transformedItems.featuredItems.length;
</script>

{#if hasItems}
  <EventPreviewList
    id={data.sys?.id}
    {title}
    class={className}
    items={transformedItems.items || []}
    featuredItems={transformedItems.featuredItems || []}
    days={transformedItems.days || []}
    {isToursEPL}
    {formFactor}
    {cta}
  />
{/if}
